import { Box } from '@chakra-ui/react';
import React from 'react';

interface ConfirmEditOverlayProps
	extends React.HTMLAttributes<HTMLDivElement> {}

const ConfirmEditOverlay: React.FC<ConfirmEditOverlayProps> = props => {
	return (
		<Box
			w="full"
			position="absolute"
			top={0}
			left={0}
			zIndex={20}
			mb={1}
			textAlign="center"
			bg="transparent"
			h="full"
			{...props}
		/>
	);
};

export default ConfirmEditOverlay;
